'use strict';

(function () {
  'use strict';

  angular.module('msCore').factory('countryGdprConfig', CountryGdprConfig);

  CountryGdprConfig.$inject = ['$rootScope', '$sessionStorage', '$log'];

  /* @ngInject */
  function CountryGdprConfig($rootScope, $sessionStorage, $log) {
    return {
      getByCountryCode: _getByCountryCode,
      getFromStorage: _getFromStorage
    };

    ////////////////

    function _getByCountryCode(countryCode, applicationMode) {
      var gdprConfig = void 0;
      var gdprConfiguration = $rootScope.gdprConfiguration;

      applicationMode = applicationMode || 'STANDARD';

      if (gdprConfiguration && gdprConfiguration.length) {
        gdprConfig = gdprConfiguration.find(function (gdprConfig) {
          return gdprConfig.countryCode === countryCode;
        });
      }

      if (gdprConfig && gdprConfig.minAgeConfiguration && gdprConfig.minAgeConfiguration.length) {
        var minAgeConfiguration = gdprConfig.minAgeConfiguration.find(function (elem) {
          return elem.applicationMode === applicationMode;
        });
        gdprConfig.minAge = minAgeConfiguration ? minAgeConfiguration.minAge : 16;
      }

      if (!gdprConfig) {
        $log.error('countryGdprConfig: Gdpr configuration for "' + countryCode + '" not found!');
        // Set default GDPR configuration
        gdprConfig = {
          minAge: 16,
          enableNotifications: true,
          isSubjectToGDPR: true,
          sexAtBirthEnabled: false,
          transgenderEnabled: false
        };
      }

      $sessionStorage.countryGdprConfig = gdprConfig;
      return gdprConfig;
    }

    function _getFromStorage() {
      if ($sessionStorage.countryGdprConfig) {
        return $sessionStorage.countryGdprConfig;
      }

      var countryCode = $sessionStorage.user.accessCode.country.countryCode;
      return _getByCountryCode(countryCode);
    }
  }
})();